import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/cart/donation';

  return API({ endpoint, method: 'delete' });
}
